import BookmarkedCompanyTab from '@/page/Profile/BookmarkedCompany'
import UserInfo from '@/page/Profile/UserInfo'
import RootLayout from '@/layout/RootLayout'
import ArticleList from '@/page/ArticleList'
import { CompanyEditor } from '@/page/CompanyEditor'
import CompanyViewer from '@/page/CompanyViewer'
import Home from '@/page/Home'
import Intro from '@/page/Intro'
import Entry from '@/page/Entry'
import BasicJobApplicationInfo from '@/page/Onboarding/BasicJobApplicationInfo'
import EducationInfo from '@/page/Onboarding/EducationInfo'
import InterestSelection from '@/page/Onboarding/InterestSelection'
import PersonalInfo from '@/page/Onboarding/PersonalInfo'
import ProgramTypeSelector from '@/page/Onboarding/ProgramTypeSelection'
import Profile from '@/page/Profile'
import { createBrowserRouter } from 'react-router-dom'
import OccupationSelection from '@/page/Onboarding/OccupationSelection'
import Tutorial from '@/page/Onboarding/Tutorial'
import UserAddress from '@/page/Onboarding/UserAddress'
import CompanyList from '@/page/CompanyList'
import Users from '@/page/admin/Users'
import NotFound from '@/page/error/NotFound'
import { checkAdmin } from './loader'

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'onboarding',
        children: [
          {
            path: 'personal-info',
            element: <PersonalInfo />,
          },
          {
            path: 'user-addr',
            element: <UserAddress />,
          },
          {
            path: 'program-type-selection',
            element: <ProgramTypeSelector />,
          },
          {
            path: 'edu-info',
            element: <EducationInfo />,
          },
          {
            path: 'basic-job-application-info',
            element: <BasicJobApplicationInfo />,
          },
          {
            path: 'interest',
            element: <InterestSelection />,
          },
          {
            path: 'occupation',
            element: <OccupationSelection />,
          },
          {
            path: 'tutorial',
            element: <Tutorial />,
          },
        ],
      },
      {
        path: 'intro',
        element: <Intro />,
      },
      {
        path: 'login',
        element: <Entry />,
      },
      {
        path: 'user/profile/',
        element: <Profile />,
        children: [
          {
            index: true,
            element: <UserInfo />,
          },
          {
            path: 'bookmarked-company',
            element: <BookmarkedCompanyTab />,
          },
        ],
      },
      {
        path: 'company',
        children: [
          {
            index: true,
            element: <CompanyList />,
          },
          {
            path: 'new',
            element: <CompanyEditor />,
          },
          {
            path: ':id/edit',
            element: <CompanyEditor />,
          },
          {
            path: ':id/view',
            element: <CompanyViewer />,
          },
        ],
      },
      {
        path: 'article/list',
        element: <ArticleList />,
      },
      {
        path: 'admin',
        errorElement: <NotFound />,
        loader: checkAdmin,
        children: [{ path: 'user', element: <Users /> }],
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
])

export default router
